import classNames from 'classnames';
import * as React from 'react';
import './Loading.scss';

export interface LoadingProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
    style?: React.CSSProperties;
    size?: 'normal' | 'small';
    inline?: boolean;
    'data-cy'?: string;
}

export const Loading: React.FC<LoadingProps> = React.memo(
    ({ className = '', inline = false, size = 'normal', style = {}, ...props }) => (
        <div
            aria-busy={true}
            aria-valuemax={100}
            aria-valuemin={0}
            className={classNames(`loading${size === 'small' ? '-small' : ''}`, className)}
            role="progressbar"
            style={{ ...style, display: inline ? 'inline-block' : 'block' }}
            {...props}
        />
    ),
);
Loading.displayName = 'Loading';
